import { struct } from 'io-ts/Decoder';

import { Id } from '../../../comment/Id';
import { ParentId } from '../../../comment/ParentId';

export const Params = struct({
	parentId: ParentId,
	commentId: Id,
});
